import { render } from "./Questionnaire.vue?vue&type=template&id=651b277e&scoped=true&ts=true"
import script from "./Questionnaire.vue?vue&type=script&lang=ts"
export * from "./Questionnaire.vue?vue&type=script&lang=ts"

import "./Questionnaire.vue?vue&type=style&index=0&id=651b277e&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651b277e"]])

export default __exports__